"use client"

import { effectivePrice, type Dish } from "@/lib/api"

interface PriceDisplayProps {
  dish: Dish
  className?: string
  oldClassName?: string
  badge?: boolean
}

export default function PriceDisplay({
  dish,
  className = "text-lg sm:text-xl font-bold text-primary",
  oldClassName = "text-sm text-muted-foreground line-through",
  badge = true,
}: PriceDisplayProps) {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("pt-AO", {
      style: "currency",
      currency: "AOA",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price)
  }

  const isPromo = !!dish.emPromocao && dish.precoPromocional != null

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {isPromo && <span className={oldClassName}>{formatPrice(dish.preco)}</span>}
      <span className={className}>{formatPrice(effectivePrice(dish))}</span>
      {isPromo && badge && (
        <span className="bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">
          Promoção
        </span>
      )}
    </div>
  )
}
